"use client";

import type { JSX } from "react";
import { cva, type VariantProps } from "class-variance-authority";

const skeletonVariants = cva(
  "relative w-full rounded-2xl overflow-hidden",
  {
    variants: {
      aspectRatio: {
        square: "aspect-square",
        video: "aspect-video",
        portrait: "aspect-[3/4]",
      },
    },
    defaultVariants: {
      aspectRatio: "square",
    },
  }
);

interface SkeletonTileProps extends VariantProps<typeof skeletonVariants> {
  className?: string;
}

export function SkeletonTile({ aspectRatio, className }: SkeletonTileProps): JSX.Element {
  return (
    <div
      className={skeletonVariants({ aspectRatio, className })}
      style={{ minHeight: "200px" }}
      role="status"
      aria-label="Loading content"
    >
      <div className="absolute inset-0 bg-gray-200 animate-pulse" />
      <div
        className="absolute inset-0"
        style={{
          background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.8) 50%, transparent 100%)",
          width: "100%",
          animation: "shimmer 2.5s ease-in-out infinite",
          WebkitAnimation: "shimmer 2.5s ease-in-out infinite"
        }}
      />
      <span className="sr-only">Loading...</span>
    </div>
  );
}
